//加入会议页
import React, { useState, useEffect, useLayoutEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next'
import './PhoneMask.css';

interface ComponentProps {
}

const PhoneMask: React.FC<ComponentProps> = (props) => {
    const { t } = useTranslation()

    const [show, setShow] = useState(false)

    const isWechat = () => {
        return /MicroMessenger/i.test(window.navigator.userAgent);
    }

    useLayoutEffect(() => {
        if (isWechat()) {
            setShow(true)
        } else {
            setShow(false)
        }
    }, [])

    if (show) {
        return (
            <div className="mask">
                <div className='mobile-content-div'>
                    <div className='mobile-content-div-top'>{t('click.right')}···</div>
                    <div className='mobile-content-div-center'>{t('select.open')}</div>
                    <div className='browser-div'></div>
                </div>
                <div className='mobile-line-div' >

                </div>
            </div>
        )
    } else {
        return (
            <></>
        )
    }
}

export default PhoneMask


